import { render } from "./addSetting.vue?vue&type=template&id=37b5d64f"
import script from "./addSetting.vue?vue&type=script&lang=js"
export * from "./addSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__